/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VmcLinkedAccountState } from './vmcLinkedAccountState';


export interface VmcLinkedAccountInfo { 
    account_number: string;
    id: string;
    org_id: string;
    state: VmcLinkedAccountState;
    created_at: Date;
    updated: Date;
    updated_by_user_id: string;
    updated_by_user_name: string;
}
export namespace VmcLinkedAccountInfo {
}


